// Zentrale Scroll-Reveal-Utility — ersetzt Einzelfall-Implementierungen
// Nutzung: data-reveal="fade-up" auf jedem Element, das beim Scrollen erscheinen soll
//
// Fail-Safe: kult-tokens.css versteckt [data-reveal] nur, wenn <html> die
// Klasse "kult-motion-ready" trägt. Diese Klasse wird ausschließlich hier
// gesetzt — läuft dieses Skript aus irgendeinem Grund nicht (Ladefehler,
// CSP, o.ä.), bleibt aller Content sichtbar statt dauerhaft opacity:0.
//
// Theme-Editor: 'shopify:section:load' rendert Sections neu; observe(e.target)
// registriert die neuen Elemente, sonst blieben sie bis zum Reload unsichtbar.
(function() {
  if (window.__kultMotionInit) return;
  window.__kultMotionInit = true;
  document.documentElement.classList.add('kult-motion-ready');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); });
  }, { threshold: 0.15 });
  function observe(root) {
    root.querySelectorAll('[data-reveal]').forEach(el => { if (!el.classList.contains('is-visible')) observer.observe(el); });
    // Gestaffelte Reveals: Kinder eines [data-reveal-stagger]-Containers erscheinen mit 60 ms Versatz
    root.querySelectorAll('[data-reveal-stagger]').forEach(el => {
      if (el.classList.contains('is-visible')) return;
      Array.from(el.children).forEach((child, i) => { child.style.transitionDelay = Math.min(i * 60, 480) + 'ms'; });
      observer.observe(el);
    });
  }
  observe(document);
  document.addEventListener('shopify:section:load', (e) => { if (e.target && e.target.querySelectorAll) observe(e.target); });
})();
